// extracted by mini-css-extract-plugin
module.exports =  {"tour":"a10a3f92e9--tour--tlcSj","title":"a10a3f92e9--title--i0cQx","content":"a10a3f92e9--content--SuGVh","layout":"a10a3f92e9--layout--JZHnf","text":"a10a3f92e9--text--AXwAG"};